<div class="content-wrapper" fxLayoutAlign="{{position}} center" fxLayout="row">
    <img *ngIf="!hideIcon" [src]="iconUrl ? iconUrl : 'assets/playbison/' + iconName" alt="icon-profile-header" />
    <h1 class="header"><ng-content></ng-content></h1>
</div>
